export default __webpack_public_path__ + "static/media/iphone-notif.79db2b7d.mp3";